export default __webpack_public_path__ + "static/Image-A-Decade-of-Dedication-9b78f6ed1dd3de38c2b0fcb9dc65ae1a.jpg";